
      import { getBrowserAppTitle } from "/src/lib/browserBranding.ts";

      document.title = getBrowserAppTitle(window.location.hostname);
    